export async function hashPasswordSHA1(password) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-1', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // Convertit le buffer en tableau d'octets
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Convertit le tableau en chaîne hexadécimale
    return hashHex;
}